import { render, staticRenderFns } from "./BooleanV1Properties.vue?vue&type=template&id=ad77f4a2&"
import script from "./BooleanV1Properties.vue?vue&type=script&lang=js&"
export * from "./BooleanV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports